import {
  AppConstants,
  conceptCodes,
  MLY_IDS,
  stepTypes,
} from "../../../../constants/constant";
import {
  FormValues,
  SchedulerConfig,
} from "../../../../Interface/scheduler/form";
import apiConfig from "../../../../service/apiConfig";

export const LeadApiCallHandler = (
  bookingWrapperEnabled: boolean,
  step: number,
  totalSteps: number,
  upsellEnabled: boolean,
  formConfig: SchedulerConfig,
  formValues: FormValues,
) => {
  if (bookingWrapperEnabled) {
    if (!upsellEnabled) {
      if (
        step === totalSteps - 1 ||
        (isJUKPaymentStep(formConfig, totalSteps) && step === totalSteps - 2) ||
        (formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE &&
          isJUKEstimateUndefined(formValues, formConfig, step))
      ) {
        return apiConfig.createLeadApiURL;
      } else {
        return apiConfig.captureLeadApiURL;
      }
    } else {
      if (
        (formValues.servicetype === MLY_IDS.COMMERCIAL ||
          (step === totalSteps - 1 && isConfigUndefined(formValues))) &&
        formValues.isMlyFlow
      ) {
        return apiConfig.createLeadApiURL;
      }
      return apiConfig.captureLeadApiURL;
    }
  }
  return apiConfig.bookingApiURL;
};

const isConfigUndefined = (formValues: FormValues) => {
  return (
    formValues.servicetype === MLY_IDS.RESIDENTIAL &&
    formValues.isMLYJSONUndefined
  );
};

export const push5UMB17Text = (
  bookingWrapperEnabled: boolean,
  step: number,
  totalSteps: number,
  formConfig: SchedulerConfig,
  formValues: FormValues,
) => {
  if (bookingWrapperEnabled) {
    if (
      step === totalSteps - 1 ||
      (formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE &&
        isJUKEstimateUndefined(formValues, formConfig, step)) ||
      (isJUKPaymentStep(formConfig, totalSteps) && step === totalSteps - 2)
    ) {
      return false;
    } else {
      return true;
    }
  }
  return false;
};

export const getBookingAPIKey = (bookingWrapperEnabled: string) => {
  if (bookingWrapperEnabled === "true") {
    return apiConfig.WRAPPER_API_KEY;
  }
  return apiConfig.API_KEY;
};

export const getEndpoint = (formValues: FormValues) => {
  if (formValues.bookingWrapper === "true") {
    return apiConfig.createLeadApiURL;
  }
  return apiConfig.bookingApiURL;
};

export const isJUKPaymentStep = (
  formConfig: SchedulerConfig,
  total: number,
) => {
  if (
    formConfig?.conceptCode === conceptCodes.JUK_CONCEPT_CODE &&
    formConfig.steps?.[total - 1]?.steptype ===
      AppConstants.PAYMENT_IFRAME_SECTION
  ) {
    return true;
  }
  return false;
};

export const isJUKEstimateUndefined = (
  formValues: FormValues,
  formConfig: SchedulerConfig,
  current: number,
) => {
  if (
    formValues?.estimatedPrice === "--" &&
    formConfig.steps?.[current]?.steptype === stepTypes.HOW_WE_CAN_REACH
  )
    return true;
  return false;
};

export const redirectToConfirmation = (
  formValues: FormValues,
  formConfig: SchedulerConfig,
  current: number,
) => {
  if (
    (formConfig.steps?.[current]?.steptype === AppConstants.REQUEST_TIME_TYPE &&
      formValues.isCallBackEnabled) ||
    isJUKEstimateUndefined(formValues, formConfig, current)
  ) {
    return true;
  }
  return false;
};
